export interface NAV_MENU {
  name?: string;
  index?: number;
  isCompleted?: boolean;
  url?: string[];
}
